import styles from "./CartPage.module.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import useAxios from "../Hooks/useAxios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
const CartPage = () => {
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const axios = useAxios();
  const navigate = useNavigate();
  const [allProducts, setAllProducts] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const [shippingText, setShippingText] = useState("");
  const [dataReload, setDataReload] = useState(false);
  useEffect(() => {
    axios
      .get(backend_base + "/order/cart")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Products");
          console.log(res.data);
          setAllProducts(res.data.products);
          setSubtotal(res.data.subtotal);
          res.data?.subtotal < 11000
            ? setShippingText(
                "あと " + (11000 - res.data?.subtotal) + " 円で送料無料"
              )
            : setShippingText("");
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [dataReload]);
  const cartPurchase = () => {
    //change this when you integrate payment
    navigate("/cart-item/details");
    // axios
    //   .post(backend_base + "/order/confirm")
    //   .then((res) => {
    //     if (res.status === 201 || res.status === 200) {
    //       console.log("Successfully Bought Items");
    //       navigate("/purchase-success");
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
  };
  const [recheckCart, setRecheckCart] = useState(false);
  const alterCartCheck = () => {
    setRecheckCart(!recheckCart);
  };
  const changeCart = (index, id, count, actionType) => {
    console.log(id);
    console.log(count);
    axios
      .post(backend_base + "/order/cart", {
        product: id,
        quantity: actionType === "delete" ? 0 : 1,
        action: actionType === undefined ? "" : actionType,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log(res.data);
          console.log("Successfully Changed Cart");
          setSubtotal(res.data.sub_total);
          const temp = Array.from(allProducts);
          if (count === 0) {
            temp.splice(index, 1);
          } else {
            temp[index].quantity = count;
          }
          alterCartCheck();
          // setAllProducts(temp);
          setDataReload((prev) => !prev);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <>
      <Header cartChanged={recheckCart} />
      {(!allProducts ||
        !Array.isArray(allProducts) ||
        allProducts.length === 0) && (
        <div className={styles.main_div_2}>
          <div className={styles.head100}>お買物カート</div>
          <div className={styles.box100}>
            <div className={styles.text100}>
              お買物カートにアイテムはありません。
            </div>
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/top");
            }}
            className={styles.btn999}
          >
            マイページ
          </div>
        </div>
      )}
      {allProducts && Array.isArray(allProducts) && allProducts.length > 0 && (
        <div className={styles.main_div}>
          <div className={styles.header}>お買物カート</div>
          <div className={styles.products_main}>
            {allProducts &&
              Array.isArray(allProducts) &&
              allProducts.length > 0 &&
              allProducts.map((item, index) => {
                console.log(item);
                return (
                  <div className={styles.single_product_row} key={index}>
                    <div className={styles.single_product_row_image_section}>
                      <div className={styles.single_product_row_image_main}>
                        <img
                          className={styles.single_product_row_image}
                          src={item.product.thumbnail}
                          alt="img"
                        />
                      </div>
                      <div className={styles.single_product_row_image_text}>
                        {item.product.product_category.name +
                          " " +
                          item.product.product_type +
                          " "}{" "}
                        <br />
                        <span>{item.product.size_page}</span>
                      </div>
                    </div>
                    <div className={styles.spr_count_main}>
                      <div className={styles.spr_count_header}>個数</div>
                      <div className={styles.spr_count_section}>
                        <div className={styles.sprc_top}>
                          <div
                            onClick={() => {
                              changeCart(
                                index,
                                item.product.id,
                                item.quantity - 1,
                                item.quantity === 0 ? "delete" : "-"
                              );
                            }}
                            className={styles.sprc_minus_div}
                          ></div>
                          <div className={styles.sprc_count_div}>
                            {item.quantity}
                          </div>
                          <div
                            onClick={() => {
                              changeCart(
                                index,
                                item.product.id,
                                item.quantity + 1,
                                "+"
                              );
                            }}
                            className={styles.sprc_plus_div}
                          ></div>
                        </div>
                        <div
                          onClick={() => {
                            changeCart(index, item.product.id, 0, "delete");
                          }}
                          className={styles.sprc_bottom}
                        >
                          削除
                        </div>
                      </div>
                    </div>
                    <div className={styles.spr_price_main}>
                      {new Intl.NumberFormat("ja-JP", {
                        style: "currency",
                        currency: "JPY",
                      }).format(item.product.sale_price)}
                    </div>
                  </div>
                );
              })}
            <div className={styles.single_product_row_total}>
              商品合計
              <div className={styles.single_product_total_number}>
                {new Intl.NumberFormat("ja-JP", {
                  style: "currency",
                  currency: "JPY",
                }).format(subtotal)}
              </div>
            </div>
            <div className={styles.free_shipping_text}>{shippingText}</div>
          </div>
          <div className={styles.button_main_div}>
            <div
              onClick={() => {
                navigate("/onlineshop");
              }}
              className={styles.button1}
            >
              お買い物へ戻る
            </div>
            <div onClick={cartPurchase} className={styles.button2}>
              ご注文手続きへ
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};
export default CartPage;
